import { render, staticRenderFns } from "./plan-header.vue?vue&type=template&id=08cc29b4&scoped=true&"
import script from "./plan-header.component.ts?vue&type=script&lang=ts&"
export * from "./plan-header.component.ts?vue&type=script&lang=ts&"
import style0 from "./plan-header.scss?vue&type=style&index=0&id=08cc29b4&lang=scss&scoped=true&"
import style1 from "./plan-header.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cc29b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08cc29b4')) {
      api.createRecord('08cc29b4', component.options)
    } else {
      api.reload('08cc29b4', component.options)
    }
    module.hot.accept("./plan-header.vue?vue&type=template&id=08cc29b4&scoped=true&", function () {
      api.rerender('08cc29b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/railway/components/plan-header/plan-header.vue"
export default component.exports